import {Component, OnInit, Input, Pipe, ViewChild, ElementRef} from '@angular/core';
import {PopupService} from 'app/services/shared/popup.service';
import {ToastrService} from 'ngx-toastr';
import {ApplicationService} from 'app/services/application.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {FormControl, Validators, FormGroup, FormBuilder} from '@angular/forms';
import {PermitService} from 'app/services/permit.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {VehicleService} from 'app/services/vehicle.service';
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
import {CarrierService} from 'app/services/carrier.service';
import {CurrencyFormat} from 'app/pipes/currencyFormat.pipe';
import {AuthWebService} from 'app/services/authweb.service';
import {accounting} from 'accounting';
import {CorspdcService} from 'app/services/corspdc.service';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {CountryService} from 'app/services/country.service';
import {PermitTypeDocumentService} from 'app/services/permit-type-document.service';
import {DatePipe} from '@angular/common';
import {VehicleMakeService} from 'app/services/vehicle-make.service';
import {VehicleTypeService} from 'app/services/vehicle-type.service';
import {RouteService} from 'app/services/route.service';
import {environment} from '../../../../environments/environment';
import {ConfirmDialogService} from 'app/services/shared/confirm-dialog/confirm-dialog.service';

var jsPDF = require('jspdf');
require('jspdf-autotable');
declare var $;
// declare var jsPDF: any;
// @Pipe({ name: 'safeHtml' })


@Component({
    selector: 'app-renew-permit',
    templateUrl: './renew-permit.component.html',
    styleUrls: ['./renew-permit.component.css'],
    providers: [PermitTypeDocumentService, RouteService, CurrencyFormat]
})
export class RenewPermitComponent implements OnInit {
    public isLoading = false;
    helphtml;
    linkhtml;
    form: FormGroup;
    @Input() dataCntrl: any;
    userDetails: any = null;
    totalFee: any = '';
    termsFlag: boolean = false;
    public pageload = false;
    enabledBtnsFlag: boolean = false;
    @ViewChild('content') content: ElementRef;
    status_id: number;
    email_body = '';
    decl_date = new Date();
    vehicles: any = [];
    lineTotal
    isProcess: boolean = true;
    submissionAmt: any = 0;
    paidAmt: any = 0;
    invoiceNumber: any = '';
    invoiceRes: any = null;
    dueAmt: any = 0;
    debtorAccountId: any;
    accountBalance: any = 0;
    chargeInd: any = 0;
    renewCrId: any = '';
    renewFlag: boolean = false;
    country
    linkedDocs: any = [];
    listvehicles: any = [];
    myLoader: boolean = false;
    message: any = 'Proccessing. Please wait...'
    list_vehicle_make: any;
    selectedVMake: any;
    ownRoutes: any = [];
    count: any = 0;
    showBlock: boolean = false;
    permitStatus: any;
    permitStatus2: number;
    permitStatus6: number;
    isDuplicateMode: boolean = false;
    replaceVehicle: boolean = false;
    isStandard: boolean = false;
    isCorrection: boolean = false;
    isLongTermCorrection: boolean = false;
    frghtPass = '';
    applicationId;

    constructor(private sanitizer: DomSanitizer, private showModal: PopupService, private toastr: ToastrService,
                private applicationService: ApplicationService, public utility: UtilityServiceService, private permitService: PermitService,
                private router: Router, private vehicleService: VehicleService, private vehicleMakeService: VehicleMakeService,
                private carrierService: CarrierService, private crspdService: CorspdcService, private routeService: RouteService,
                private activeRoute: ActivatedRoute,
                public currformat: CurrencyFormat, private toastService: ToastNotificationService,
                private authWebService: AuthWebService,
                private countryService: CountryService,
                private service: PermitTypeDocumentService,
                private datePipe: DatePipe, private permitSevc: PermitService, private confirmDialogService: ConfirmDialogService) {

    }

    ngOnInit() {
        if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
            this.permitStatus2 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus2').Value;
            this.permitStatus6 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus6').Value;
        }
        this.userDetails = environment.authWebApi.userData.User;
        //console.log(this.userDetails);
        this.setHTMLDATA();
        this.activeRoute.params.subscribe((params: Params) => {
            if (params['type']) {
                this.renewFlag = true;
                this.renewCrId = params['crId'];
                this.getApplication(params['id']);
            }
        });

    }

    getApplication(id) {
        this.pageload = true;
        this.permitService.copyPermit(id).subscribe(res => {
            this.dataCntrl = res;
            this.dataCntrl.permittype = this.dataCntrl.permit.permit_type;
            console.log('Data Cntrl', this.dataCntrl);
            this.vehicles = this.dataCntrl.vehicles;
            this.showBlock = true;
            this.populateData();
            this.getCarrier();
            console.log('Data Cntrl', this.dataCntrl);
        }, error => {
            console.error(error);
        })
    }

    populateData() {
        this.pageload = true;
        this.chargeInd = this.dataCntrl.application.permit_type.charge_when_ind;

        this.count = this.count + 1;
        this.paidAmt = 0;
        this.dueAmt = 0;
        this.submissionAmt = 0;

        if (this.dataCntrl.vehicles == null || this.dataCntrl.vehicles == undefined) {
            this.dataCntrl.vehicles = [];
        }

        // Paid Amount
        if (this.dataCntrl.permit.application_invoice_link != null && (this.dataCntrl.permit.application_invoice_link).substring(0, 3) == 'INV') {
            if (this.dataCntrl.vehicles.length == 0) {
                this.paidAmt = this.dataCntrl.application.permit.application_fee
            } else {
                this.paidAmt = this.dataCntrl.application.permit.application_fee * this.dataCntrl.vehicles.length;
            }
        }
        if (this.dataCntrl.permit.permit_invoice_link != null && (this.dataCntrl.permit.permit_invoice_link).substring(0, 3) == 'INV') {
            if (this.dataCntrl.vehicles.length == 0) {
                this.paidAmt = this.paidAmt + this.dataCntrl.application.permit.permit_fee
            } else {
                this.paidAmt = this.paidAmt + this.dataCntrl.application.permit.permit_fee * this.dataCntrl.vehicles.length;
            }
        }

        // Total Fee
        this.totalFee = (this.dataCntrl.permit.application_fee + this.dataCntrl.permit.permit_fee);
        if (this.vehicles == null || this.vehicles.length == 0) {
            this.totalFee = this.dataCntrl.application.permit.application_fee;
            this.lineTotal = this.dataCntrl.application.permit.application_fee;
        }

        this.lineTotal = (parseFloat(this.dataCntrl.permit.application_fee) + parseFloat(this.dataCntrl.permit.permit_fee));
        this.lineTotal = this.formatCurrency(this.lineTotal);

        this.totalFee = this.formatCurrency(this.totalFee);

        // Application & Permit Fee
        if (this.vehicles.length > 0) {
            this.submissionAmt = (this.dataCntrl.permit.application_fee * this.vehicles.length) + (this.dataCntrl.permit.permit_fee * this.vehicles.length);
            this.dueAmt = this.submissionAmt - this.paidAmt;
        }
        //  this.dataCntrl.permit.application_fee = this.formatCurrency(this.dataCntrl.application.permit.application_fee);
        // this.dataCntrl.application.permit.permit_fee = this.formatCurrency(this.dataCntrl.permit.permit_fee)

        this.submissionAmt = this.formatCurrency(this.submissionAmt);
        this.paidAmt = this.formatCurrency(this.paidAmt);
        this.dueAmt = this.formatCurrency(this.dueAmt);

        this.pageload = false;
    }

    formatCurrency(value) {
        return accounting.formatMoney(value, 'R', 2, ' ', '.');
    }

    setHTMLDATA() {

        if (environment.authWebApi.systemData != null) {
            this.linkhtml = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'HTMLDec2');
        }
    }

    getCarrier() {
        this.pageload = true;
        this.carrierService.getById(this.dataCntrl.application.carrier.id).subscribe((result: any) => {
            this.setDebtorAccount(result.carrier_account_id);
            this.setCarrierData(result);
            this.pageload = false;
        }, error => {
            this.pageload = false;
        });
    }

    setDebtorAccount(carrierAccountId) {
        this.carrierService.getDebtorAccount(carrierAccountId).subscribe((result: any) => {
            this.debtorAccountId = result.customer_code;
        }, error => {
        });
    }
    changes() {
        this.form.statusChanges.subscribe(
            result =>
                this.dataCntrl.formValid = result == 'VALID' ? true : false
        );
    }
    setCarrierData(data) {
        if (data.account_balance != null) {
            this.accountBalance = data.account_balance * -1;
            if (!data.account_balance.toString().includes('R')) {
                if (parseFloat(data.account_balance) != 0) {
                    data.account_balance = -(parseFloat(data.account_balance));
                }
                data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
            }
        }
        // this.dataCntrl.carrier = data;
        this.dataCntrl.application.carrier = data;
        $('#carrierName').html(data.name);
        this.listCountries(data.country_id);
    }
    cancelApplication() {
        // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
        this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.application.carrier.id]);
        //   } else {
        //     this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete this application for a Permit Renewal?', `Click 'Yes' to delete or 'No' to return to the application`, 'Yes', 'No')
        //       .subscribe((isConfirmed) => {
        //         if (isConfirmed) {
        //           this.deleteApplication()
        //         } else {
        //           return;
        //         }
        //       });
        //   }
    }
    deleteApplication() {
        //console.log("delete application");
        this.pageload = true;

        this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x => {
            //console.log(x);
            this.deleteApp(this.dataCntrl.application.id);
            this.pageload = false;

            this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.application.carrier.id]);

        })
    }
    deleteApp(id) {
        this.applicationService.deleteApplication(id).subscribe(x => {
            //console.log(x);
        })
    }
    SubmitApplication() {
        // this.showModal.showYesNo('Confirm Application', `Are you sure you want to submit application for a Permit ?. A confirmation email will be sent to '${this.userDetails.EmailAddress}'.`, `Please access your Portal for next steps.`, 'Ok', 'Cancel')
        //     .subscribe((isConfirmed) => {
        //       if(isConfirmed) {
        //        // this.determineStatus();
        //         this.saveConfirmation();
        //       }
        //       else
        //       {
        //         return;
        //       }
        //     }
        //   );
        this.confirmDialogService.confirmThis(`Are you sure you want to submit application for a Permit ?. A confirmation email will be sent to '${this.userDetails.EmailAddress}'. Please access your Portal for next steps.`, () => {

            this.saveConfirmation();

        }, () => {
            return;
        })
    }
    saveConfirmation() {

        if (!this.termsFlag) {
            this.pageload = false;
            return this.toastService.error('Please agree the terms', 'Error');
        }

        this.updateConfm();
    }
    PayGate() {
        this.router.navigate(['/carrier/fundaccount/' + this.renewCrId]);
    }
    listCountries(id) {
        this.countryService.listCountries().subscribe((result: any) => {
            if (id != null) {
                this.country = result.find(x => x.id == id);
                this.country = this.country.desc;
            }
        }, error => {
            this.isLoading = false;
        });
    }
    checkTerms(event) {
        if (event.target.checked) {
            this.termsFlag = true;
        } else {
            this.termsFlag = false;
        }
    }
    disbledBtn() {
        let dueAmt: any = 0;
        if (!this.termsFlag) {
            return true;
        } else {
            let acntBal: any = 0;
            if (this.dataCntrl.application.carrier.account_balance != null) {
                acntBal = (this.dataCntrl.application['carrier'].account_balance).toString().replace(/\s+/g, '');
                acntBal = acntBal.replace('R', '');
                // acntBal = parseFloat(acntBal.replace("-", ""));
            }

            if (this.dueAmt != null && this.dueAmt != undefined && this.dueAmt != '') {
                dueAmt = this.dueAmt.replace(' ', '');
                dueAmt = parseFloat(dueAmt.replace('R', ''));
            }

            if (acntBal < dueAmt) {
                return true;
            } else {
                return false;
            }
        }

    }
    retrieveSubmitStatus() {
        if (this.authWebService.userData) {

            this.status_id = +environment.authWebApi.systemData.Configurations.find(config => config.Code == 'AccountStatus2').Value;
            this.dataCntrl.application.status_id = this.status_id;
            this.dataCntrl.application.submission_date = new Date();
            //console.log(this.dataCntrl.application);
            this.applicationService.putApplication(this.dataCntrl.application)
                .subscribe(result => {
                        //console.log(result);
                        this.updatePermit(this.status_id);
                        this.toastService.success(`Your permit application was submitted successfully`, 'success');
                        this.router.navigate(['carrier/permit/application/' + this.renewCrId]);
                        this.pageload = false;
                    },
                    error => {
                        //console.log(error);
                        this.pageload = false;
                        return;
                    });
        }
    }

    updatePermit(status_id) {
        this.dataCntrl['application'].permit.status_id = status_id;
        if (this.vehicles == null || this.vehicles.length == 0) {
            this.dataCntrl['application']['permit'].application_fee = parseFloat(this.dataCntrl['application']['permit'].application_fee.replace(/[^\d\.]*/g, ''));
            this.dataCntrl['application']['permit'].permit_fee = 0;
        }
        this.permitService.upadatePermit(this.dataCntrl['application']['permit']).subscribe(result => {
            this.dataCntrl['application']['permit'] = result;

        })

    }

    //New updateConfirm
    updateConfm() {
        this.pageload = true;
        if (!this.termsFlag) {
            this.pageload = false;
            return this.toastService.error('Please agree the terms', '');
        }

        if (this.dataCntrl.application.carrier?.account_balance == 0 || this.dataCntrl.application.carrier?.account_balance == null || this.dataCntrl.application.carrier?.account_balance < this.dueAmt) {

            this.confirmDialogService.confirmThis(`You have insufficient Funds. Your account balance is R'${this.accountBalance}'. Do you want to countinue to payment screen?.`, () => {
                this.router.navigate(['/carrier/fundaccount/' + this.dataCntrl.carrierID])
                return;
            }, () => {
                return;
            })
            // this.toastService.error("You cannot submit a Permit Application if Amount Paid And Amount  Due are Zero.","Insufficient Funds")
            return;
        }
        if (this.dataCntrl.application.carrier?.status_id == 33) {
            return this.toastService.error('You cannot proceed to submit this application, you are Non-Compliant because of Annual Compliance Overdue', '');
        }

        const config: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == 'SubmitEmail2');

        let payload: any = Object();
        payload['carrier_id'] = this.dataCntrl.application.carrier.id;
        payload['application_id'] = this.dataCntrl.application.id;
        payload['permit_id'] = this.dataCntrl.application.permits[0].id;
        payload['document_id1'] = null;
        payload['document_id2'] = null;
        payload['document_id3'] = null;
        payload['corspdc_type_ind'] = 3;
        payload['body_text'] = config.Value;
        payload['notes'] = null;
        payload['attachment'] = null;
        payload['subject'] = config.Description;
        payload['send_receive_ind'] = 11;
        payload['comm_type_ind'] = 3;
        payload['num_bookmarks'] = 0;
        payload['date_created'] = new Date();
        payload['date_modified'] = new Date();
        payload['user_created'] = this.userDetails.FirstName;
        payload['user_modified'] = this.userDetails.FirstName;
        payload['bookmark1_value'] = null;
        payload['bookmark2_value'] = null;
        payload['bookmark3_value'] = null;
        payload['bookmark4_value'] = null;
        payload['bookmark5_value'] = null;
        payload['bookmark6_value'] = null;
        //payload['from_person_id'] = this.dataCntrl.carrier.person_id;
        //payload['correspondence_person'] = [this.dataCntrl.carrier.person_id];
        payload['file_name'] = null;
        let oldAppId = 0;//localStorage.getItem("oldAppId");


        this.permitStatus = 11; //submitted;

        this.permitService.GenerateApplicationPermitInvoices(this.dataCntrl.application.id).subscribe((result: any) => {
            if (result.Message === 'Approved') {
                this.crspdService.savePermitCorrespondence(payload, oldAppId, this.permitStatus, true).subscribe((data: any) => {
                    this.pageload = false;
                    //this.isLoading = false;
                    if (data.isSaved) {
                        this.toastService.success(`Your permit application was submitted successfully.`, 'success');
                        this.router.navigate(['carrier/permit/application/' + this.renewCrId]);
                    } else {
                        this.toastService.error(`Submission for ${this.dataCntrl['carrier'].name}   failed.Please contact the system administrator if the problem persists.`, data.isSaved);
                    }


                }, error => {
                    this.pageload = false;
                    //this.isLoading = false;
                    this.toastService.error(`Submission for   failed.Please contact the system administrator if the problem persists.`, `${error.status} : ${error.statusText}`);
                })
            } else {
                this.toastService.error('You cannot submit a Permit Application if Amount Paid And Amount  Due are Zero.', "Insufficient Funds")
            }
        });
    }


}

